import { ROLES } from "../config/constants";
import { useAuthContext } from "../context/auth";

export function useAuth() {
  const { user } = useAuthContext();

  return {
    user: user,
    isPlaceManager:
      user?.role?.label?.toLocaleLowerCase() === ROLES.USER &&
      user?.isPlaceManager === true,
    isPlaceAdmin:
      user?.role.label?.toLocaleLowerCase() === ROLES.PLACE_ADMIN.toLowerCase(),
    isMultiPlaceAdmin: user?.isMultiPlaceAdmin,
    isAdmin:
      user?.role.label?.toLocaleLowerCase() === ROLES.SUPER_ADMIN.toLowerCase(),
    isInspector:
      user?.role.label?.toLocaleLowerCase() === ROLES.INSPECTOR.toLowerCase(),
  };
}
